<template>
  <section class="stats-bar">
    <div class="stats-wrap">
      <div class="stat-item">
        <i class="fa-solid fa-rss icon" aria-hidden="true"></i>
        <div class="text">
          <div class="value">{{ n(onlineUsers ?? 0) }}</div>
          <div class="label">{{ t('STATS.online') }}</div>
        </div>
      </div>

      <div class="stat-item">
        <i class="fa-solid fa-user icon" aria-hidden="true"></i>
        <div class="text">
          <div class="value">{{ n(generalStats?.users ?? 0) }}</div>
          <div class="label">{{ t('STATS.users') }}</div>
        </div>
      </div>

      <div class="stat-item">
        <i class="fa-solid fa-key icon" aria-hidden="true"></i>
        <div class="text">
          <div class="value">{{ n(generalStats?.caseOpenings ?? 0) }}</div>
          <div class="label">{{ t('STATS.openedCases') }}</div>
        </div>
      </div>

      <div class="stat-item">
        <i class="fa-solid fa-arrow-trend-up icon" aria-hidden="true"></i>
        <div class="text">
          <div class="value">{{ n(generalStats?.upgrades ?? 0) }}</div>
          <div class="label">{{ t('STATS.upgrades') }}</div>
        </div>
      </div>

      <div class="stat-item">
        <i class="fa-solid fa-file-contract icon" aria-hidden="true"></i>
        <div class="text">
          <div class="value">{{ n(generalStats?.contracts ?? 0) }}</div>
          <div class="label">{{ t('STATS.contracts') }}</div>
        </div>
      </div>

      <div class="stat-item">
        <i class="fa-solid fa-users icon" aria-hidden="true"></i>
        <div class="text">
          <div class="value">
            {{ n(generalStats?.arenaRoomCreated ?? generalStats?.arenaRoomsCreated ?? 0) }}
          </div>
          <div class="label">{{ t('STATS.whaleDuel') }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useStatsStore } from '@/store/stats'
import { useI18n } from 'vue-i18n'

const { t, n } = useI18n()
defineOptions({ name: 'Stats' })
const statistic = useStatsStore()
const { generalStats, onlineUsers } = storeToRefs(statistic)
</script>

<style lang="scss" scoped>
.stats-bar {
  background: $elevation1;
  width: 100%;
  padding: 1em 0;
  border-bottom: 1px solid $elevation2;

  .stats-wrap {
    display: flex;
    justify-content: center;
    padding: 18px 24px;
    align-items: center;
    gap: 48px;
    flex-wrap: wrap;
  }

  .stat-item {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    min-width: 200px;

    .icon {
      width: 32px;
      height: 32px;
      display: grid;
      place-items: center;
      font-size: 32px;
      color: $on-elevation1;
      flex: 0 0 auto;
    }

    .text {
      display: flex;
      flex-direction: column;
      line-height: 1.1;

      .value {
        font-weight: 800;
        font-size: 20px;
        color: $on-elevation1;
        letter-spacing: 0.2px;
      }

      .label {
        margin-top: 4px;
        font-weight: 700;
        font-size: 11px;
        text-transform: uppercase;
        color: $on-elevation1;
        letter-spacing: 0.6px;
        opacity: 0.9;
      }
    }
  }

  @media (max-width: 720px) {
    .stats-wrap {
      gap: 20px;
      padding: 14px 16px;
    }
    .stat-item {
      min-width: 160px;

      .text {
        .value {
          font-size: 18px;
        }
      }
    }
  }
}
</style>
